// extracted by mini-css-extract-plugin
export default {"container":"Table_container__EqFGn","scrollBox":"Table_scrollBox__FUq3z"};